import type { ReactElement } from "react";
import { memo } from "react";

export const CardFooter = memo(function MemoisedCardFooter(): ReactElement {
  return (
    <div className="flex gap-4 items-center text-grey-500">
      <a href="https://hortis.com/privacy" target="_blank" rel="noreferrer">
        <span className="text-sm">Privacy</span>
      </a>
      <span className="text-[10px] text-gray-400">•</span>
      <a href="https://hortis.com/terms" target="_blank" rel="noreferrer">
        <span className="text-sm">Terms</span>
      </a>
    </div>
  );
});
